import React from 'react';
import Box from '@mui/material/Box';
import { dsV2 } from '../../ds-v2-tokens';

/**
 * Ligne label / valeur (liste de définitions) du Design System V2 : libellé discret à gauche,
 * valeur alignée à droite, séparateur bas sauf `last`. Présentation pure.
 */
export type FieldRowProps = {
  label: React.ReactNode;
  value: React.ReactNode;
  last?: boolean;
};

export const FieldRow = ({ label, value, last }: FieldRowProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: '12px',
      padding: last ? '8px 0 0' : '8px 0',
      borderBottom: last ? 'none' : `1px solid ${dsV2.color.borderLight}`,
      '&:first-of-type': { paddingTop: 0 },
    }}
  >
    <Box sx={{ fontSize: '11.5px', color: dsV2.color.t3, flexShrink: 0, whiteSpace: 'nowrap' }}>{label}</Box>
    <Box
      sx={{ fontSize: '12.5px', fontWeight: 500, color: dsV2.color.noir, textAlign: 'right', wordBreak: 'break-word' }}
    >
      {value ?? '—'}
    </Box>
  </Box>
);

export default FieldRow;
